import { render, staticRenderFns } from "./Verified.vue?vue&type=template&id=80568fe6&scoped=true&"
import script from "./Verified.vue?vue&type=script&lang=js&"
export * from "./Verified.vue?vue&type=script&lang=js&"
import style0 from "./Verified.vue?vue&type=style&index=0&id=80568fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80568fe6",
  null
  
)

component.options.__file = "Verified.vue"
export default component.exports